module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/spot01_point-ad4fc8f42ba0f6c698064bd436c75c43.jpg";